<div class="camera-indicator">
  <mat-icon
    *ngIf="cameraConnected$ | async as cameraConnected"
    svgIcon="cm:video-camera"
    [ngClass]="cameraConnected ? 'success' : 'error'"
  ></mat-icon>
</div>
